import {UserSettings} from "../../@types/response";

const TZ_OFFSET_RE = /([zZ]|[+\-]\d{2}:?\d{2})$/;

export const toEpochMs = (value: unknown): number | null => {
    if (value == null) return null;
    if (value instanceof Date) {
        const t = value.getTime();
        return Number.isFinite(t) ? t : null;
    }
    if (typeof value === "number") {
        if (!Number.isFinite(value)) return null;
        return value < 1e12 ? value * 1000 : value;
    }
    if (typeof value === "string") {
        const raw = value.trim();
        if (!raw) return null;
        if (/^\d+$/.test(raw)) {
            const n = Number(raw);
            return Number.isFinite(n) ? toEpochMs(n) : null;
        }
        let iso = raw.replace(" ", "T");
        if (!TZ_OFFSET_RE.test(iso)) {
            iso += "Z";
        }
        const t = Date.parse(iso);
        return Number.isFinite(t) ? t : null;
    }
    return null;
};

export const toLocalDate = (value: unknown): Date | null => {
    const t = toEpochMs(value);
    return t == null ? null : new Date(t);
};

export const formatDate = (date: Date, year: boolean = false): string => {

    let resultParts = [date.getDate().toString().padStart(2, '0'), (date.getMonth() + 1).toString().padStart(2, '0')]
    if (year) {
        resultParts.push(date.getFullYear().toString().padStart(2, '0'))
    }

    return resultParts.join('/') + ' ' +
        date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0')
}

export const formatTimestamp = (time: number, year: boolean = false): string => {
    return formatDate(new Date(time), year)
}

export const getSbvMarket = (marketId: string): { market: number, svb: null | string } => {
    if (!marketId.includes('@'))
        return {market: parseInt(marketId), svb: null};
    const mp = marketId.split('@')
    return {market: parseInt(mp[0]), svb: mp[1]};
}

export const toMoney = (value?: number): string => {
    if (!value) return '0'
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export const getUserSettings = (): UserSettings | null => {
    const raw = localStorage.getItem("userSettings");
    if (!raw) return null;
    try {
        return JSON.parse(raw) as UserSettings;
    } catch {
        return null;
    }
}